import { z } from "zod";

import { UNLIMITED_CAPACITY } from "../../../shared/capacity/overCapacity";

const nonEmptyString = z.string().min(1);
const nonNegativeNumber = z.number().nonnegative();

export const sellableModuleDtoSchema = z.object({
  id: nonEmptyString,
  slug: nonEmptyString,
  nameEn: nonEmptyString,
  nameAr: nonEmptyString,
  descriptionEn: nonEmptyString,
  descriptionAr: nonEmptyString,
  purchasingPrice: nonNegativeNumber,
  sellingPrice: nonNegativeNumber.nullable(),
  createdAt: nonEmptyString,
  updatedAt: nonEmptyString,
});

// A plain array — GET /modules/sellable carries no pagination envelope.
export const sellableModulesResponseDtoSchema = z.object({
  data: z.array(sellableModuleDtoSchema),
});

export const sellableModuleResponseDtoSchema = z.object({
  data: sellableModuleDtoSchema,
});

// `GET /modules/capacity`: for each module NASAM sold this world, the client
// companies it may give it. A line sold with no ceiling has `quantity: null`
// -- unlimited, as is exactly 99999 (agreed with the backend).
export const moduleCapacityDtoSchema = z
  .object({
    moduleId: nonEmptyString,
    quantity: z.number().nullable(),
    used: z.number(),
    remaining: z.number(),
    overage: z.number(),
  })
  .transform(({ moduleId, quantity, used, remaining }) => ({
    moduleId,
    capacity:
      quantity === null || quantity === UNLIMITED_CAPACITY
        ? ("unlimited" as const)
        : { paidQuantity: quantity, used, remaining },
  }));

export const moduleCapacitiesResponseDtoSchema = z.object({
  data: z.array(moduleCapacityDtoSchema),
});

export const sellingPriceWriteDtoSchema = z.object({
  sellingPrice: nonNegativeNumber,
});

export type SellableModuleDto = z.infer<typeof sellableModuleDtoSchema>;
export type SellingPriceWriteDto = z.infer<typeof sellingPriceWriteDtoSchema>;
